
const get_font_size = () => {
  if (typeof getComputedStyle === "function") {
    return getComputedStyle(document.documentElement).fontSize;
  }
  return "16px";
}

/**
 * Calculate current rem size in px.
 *
 * @param rem
 * @return {float} pixels
 */
const rem_to_px = rem => {
  if (typeof(rem) === "string") {
    if (rem.endsWith("rem")) {
      rem = rem.substring(0, rem.length - 3);
    }
    rem = parseFloat(rem);
  }
  return rem * parseFloat(get_font_size());
};

const px_to_rem = px => {
  return px / parseFloat(get_font_size());
}

export{ rem_to_px, px_to_rem };
